import { Store } from "@store";
import { trackEvent } from "@utils/analytics/event-analytics";
import { setLanugage } from "@utils/api/axiosInstance";
import { WEB_ENGAGE } from "@utils/constants";
import { isLoggedIn } from "@utils/user/userCheck";
import Head from "next/head";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getAllCommunityEvents } from "src/pujaModule/queries/pujas.queries";
import PujaListView from "../../src/pujaModule/views/pujaListView";
import { useDispatch } from "react-redux";
import { deleteRegistrationDetails } from "@utils/reduxToolkit/features/registrationDetailsSlice";

const Puja = ({ data, userData, lang }) => {
  const { t } = useTranslation();
  const { dispatch } = useContext(Store);
  const reduxDispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: "SET_DATA", payload: { userData, lang } });

    trackEvent(
      WEB_ENGAGE.SCREEN_NAMES.EVENT_LIST +
        " " +
        WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED,
      {
        [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]:
          WEB_ENGAGE.SCREEN_NAMES.EVENT_LIST,
      }
    );
    reduxDispatch(deleteRegistrationDetails());
  }, [dispatch, lang, userData]);

  return (
    <div>
      <Head>
        <title>{t("pujas-or-utsav-hindu-temple-online-puja-and-prasad")}</title>
        <meta
          name="keywords"
          content={t(
            "utsav-utsavapp-kriya-page-of-utsav-app-e-puja-booking-online-puja-booking-online-puja-online-darshan-hindi-devotional-puja-app-darshan-app-online-puja-app-free-online-puja-hinduism-sanatan-dharma-lord-shiva-lord-krishna-indian-heritage-virtual-festivals-virtual-puja-locate-various-temple-connect-with-community-temples-of-india-festivals-community-platform-download-utsav-app-community-events-india-events-bhagavad-gita-yoga-devotion-festivals-spirituality-divine-god-belief"
          )}
        />
        <meta
          name="description"
          content={t(
            "offer-online-pujas-at-500-hindu-temples-at-kashi-vrindavan-ujjain-and-receive-holy-prasad-at-home"
          )}
        />

        <meta
          property="og:title"
          content={t("pujas-or-utsav-hindu-temple-online-puja-and-prasad")}
        />
        <meta
          property="og:description"
          content={t(
            "offer-online-pujas-at-500-hindu-temples-at-kashi-vrindavan-ujjain-and-receive-holy-prasad-at-home"
          )}
        />

        <meta property="og:url" content="https://utsavapp.in/puja" />
        <meta
          property="og:image"
          content="https://d3k1i85mml78tf.cloudfront.net/Feeds/1705393164851_post_image_2.jpg"
        />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://utsavapp.in/puja" />
      </Head>

      <PujaListView data={data} />
    </div>
  );
};

export async function getServerSideProps(context) {
  const { req, res, locale, query } = context;

  try {
    let loggedIn = await isLoggedIn(req.headers.cookie, res);

    let userData = null;
    let lang = locale;

    if (loggedIn.value) {
      userData = loggedIn.data;
      //if (locale === LANGUAGE.ENGLISH) lang = loggedIn.lang;
    }
    setLanugage(lang);

    if (query) {
      if (query.trackingID) {
        let trackingID = query.trackingID;

        return {
          redirect: {
            destination: `/puja/track?trackingID=${trackingID}`,
            permanent: false,
          },
        };
      }
    }

    const { data, err } = await getAllCommunityEvents({
      accessToken: userData?.accessToken,
    });


    if (err) {
      return {
        redirect: {
          destination: "/home",
          permanent: false,
        },
      };
    }

    return {
      props: {
        data: data,
        userData: userData,
        lang: lang,
      },
    };
  } catch (err) {
    return {
      redirect: {
        destination: "/home",
        permanent: false,
      },
    };
  }
}

export default Puja;
